import { useEffect } from "react";
import { useAuthStore } from "@/store/authStore";
import { api } from "@/lib/api";
import { useMe } from "./hooks";

/**
 * Uygulama mount edildiğinde refresh cookie ile access token almayı dener.
 * Layout'un üst seviyesinde bir kere render edilmeli.
 */
export default function AuthInit() {
  const setToken = useAuthStore((s) => s.setToken);
  const setAuthReady = useAuthStore((s) => s.setAuthReady);
  const accessToken = useAuthStore((s) => s.accessToken);

  useEffect(() => {
    // Memory'de zaten token varsa (hot reload vs.) refresh atlamak yeterli
    if (accessToken) {
      setAuthReady(true);
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const data = await api.post<{ accessToken: string | null }>("/api/auth/refresh");
        if (!cancelled && data.accessToken) setToken(data.accessToken);
      } catch {
        // Refresh başarısız — kullanıcı giriş yapmamış veya cookie yok
      } finally {
        if (!cancelled) setAuthReady(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // me query'i tetikle (access token varsa)
  useMe();

  return null;
}
